module.exports = __webpack_public_path__ + "static/media/013.e8e49554.png";